export default "__VITE_ASSET__DeHuGL7$__"